/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePaymentResponseDataAdyenData
 */
export interface CreatePaymentResponseDataAdyenData {
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentResponseDataAdyenData
     */
    verificationToken?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentResponseDataAdyenData
     */
    resultCode: string;
    /**
     * 
     * @type {object}
     * @memberof CreatePaymentResponseDataAdyenData
     */
    action?: object;
}

export function CreatePaymentResponseDataAdyenDataFromJSON(json: any): CreatePaymentResponseDataAdyenData {
    return CreatePaymentResponseDataAdyenDataFromJSONTyped(json, false);
}

export function CreatePaymentResponseDataAdyenDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentResponseDataAdyenData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'verificationToken': !exists(json, 'verificationToken') ? undefined : json['verificationToken'],
        'resultCode': json['resultCode'],
        'action': !exists(json, 'action') ? undefined : json['action'],
    };
}

export function CreatePaymentResponseDataAdyenDataToJSON(value?: CreatePaymentResponseDataAdyenData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'verificationToken': value.verificationToken,
        'resultCode': value.resultCode,
        'action': value.action,
    };
}

